// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#nav-bar-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  background-color: var(--primaryTheme);
  display: flex;
  padding: 1rem;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  box-sizing: border-box;
  color: var(--primaryFontTheme);
  box-shadow: 1px 1px 8px 1px #f9543a;
  z-index: 999;
}
#nav-bar-wrapper #navTitle {
  border-left: 1px solid var(--primaryFontTheme);
  padding-left: 32px;
}
#nav-bar-wrapper #navTitle h2 {
  margin: 0;
  font-weight: normal;
}
#nav-bar-wrapper a {
  cursor: pointer;
  color: white;
  text-decoration: none;
}
#nav-bar-wrapper a:hover {
  text-decoration: underline;
}
#nav-bar-wrapper #nav-main-part {
  display: flex;
  align-items: center;
  gap: 32px;
}
#nav-bar-wrapper #nav-main-part .logo {
  padding-top: 5px;
}
#nav-bar-wrapper #nav-main-part nav {
  display: flex;
  gap: 16px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  align-self: flex-end;
}
#nav-bar-wrapper #secondary-menu {
  color: white;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  gap: 16px;
}
#nav-bar-wrapper #secondary-menu a {
  display: flex;
  gap: 6px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
#nav-bar-wrapper #secondary-menu a svg {
  vertical-align: middle;
  height: 20px;
  width: 20px;
  align-self: flex-end;
}

@media only screen and (max-width: 899px) {
  #navTitle {
    padding-left: 12px !important;
  }
  #nav-bar-wrapper #nav-main-part {
    gap: 12px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Navigation/NavigationBar.scss"],"names":[],"mappings":"AAKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,qCAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;EACA,sBAAA;EACA,8BAAA;EACA,mCAAA;EACA,YAAA;AAJF;AAME;EACE,8CAAA;EACA,kBAAA;AAJJ;AAMI;EACE,SAAA;EACA,mBAAA;AAJN;AAQE;EACE,eAAA;EACA,YAAA;EACA,qBAAA;AANJ;AAQI;EACE,0BAAA;AANN;AAUE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AARJ;AAUI;EACE,gBAAA;AARN;AAWI;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;AATN;AAaE;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;AAXJ;AAaI;EACE,aAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAXN;AAaM;EACE,sBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AAXR;;AAiBA;EACE;IACE,6BAAA;EAdF;EAgBA;IACE,oBAAA;EAdF;AACF","sourcesContent":["@import \"../../tokens.scss\";\n\n$myColor: red;\n$navigationBarBackgroundColor: $primaryColor;\n\n#nav-bar-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: var(--primaryTheme);\n  display: flex;\n  padding: 1rem;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  box-sizing: border-box;\n  color: var(--primaryFontTheme);\n  box-shadow: 1px 1px 8px 1px $secondaryColor;\n  z-index: 999;\n\n  #navTitle {\n    border-left: 1px solid var(--primaryFontTheme);\n    padding-left: 32px;\n\n    h2 {\n      margin: 0;\n      font-weight: normal;\n    }\n  }\n\n  a {\n    cursor: pointer;\n    color: white;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  #nav-main-part {\n    display: flex;\n    align-items: center;\n    gap: 32px;\n\n    .logo {\n      padding-top: 5px;\n    }\n\n    nav {\n      display: flex;\n      gap: 16px;\n      font-size: 16px;\n      font-weight: 600;\n      color: white;\n      align-self: flex-end;\n    }\n  }\n\n  #secondary-menu {\n    color: white;\n    font-size: 16px;\n    font-weight: 600;\n    display: flex;\n    gap: 16px;\n\n    a {\n      display: flex;\n      gap: 6px;\n      justify-content: center;\n      align-items: center;\n      cursor: pointer;\n\n      svg {\n        vertical-align: middle;\n        height: 20px;\n        width: 20px;\n        align-self: flex-end;\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 899px) {\n  #navTitle {\n    padding-left: 12px !important;\n  }\n  #nav-bar-wrapper #nav-main-part {\n    gap: 12px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
